import src from "IMAGE";
export default { src, width: 505, height: 505, blurWidth: 0, blurHeight: 0};
